<template>
    <div class="columns">
        <div class="column">
            <div class="level">
                <div class="level-left">
                    <div class="title">Edit Profile</div>
                </div>
            </div>
            <div class="is-12">
                <form novalidate @submit.prevent="submitForm">
                    <div class="level">
                        <div class="column is-6 padding-left-0">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" value="" name="email" v-model="form.email" disabled>
                                </div>
                            </div>
                            <div class="column"></div>
                            <div class="field">
                                <label class="label">Type of User</label>
                                <div class="columns is-marginless is-mobile">
                                    <div class="column is-narrow column-checkbox">
                                        <input type="radio" name="role_id" v-model.number="form.role_id" value="3" checked @change="setChanged">
                                    </div>
                                    <div class="column column-checkbox">
                                        <span class="has-text-weight-bold">User</span>
                                        <p class="label is-size-7 has-text-weight-normal">Can manage reviews</p>
                                    </div>
                                </div>
                                <div class="columns is-marginless is-mobile">
                                    <div class="column is-narrow column-checkbox">
                                        <input type="radio" name="role_id" v-model.number="form.role_id" value="2" @change="setChanged">
                                    </div>
                                    <div class="column column-checkbox">
                                        <span class="has-text-weight-bold">Admin</span>
                                        <p class="label is-size-7 has-text-weight-normal">Has full access, including user management, billing and all reports</p>
                                    </div>
                                </div>
                                <div class="column"></div>
                                <div class="column has-text-right is-paddingless">
                                    <button class="button is-button-blue-outline is-button-medium has-button-medium-min-max-width margin-right-10" :disabled="sending" type="reset" @click="cancel">CANCEL</button>
                                    <button type="submit" :class="[{ 'is-loading': fetching || sending }, 'button is-button-blue is-button-medium has-button-medium-min-max-width']" :disabled="sending || !has_changed" >SAVE</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import ApiResource from '../../api/ApiResource'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Edit User'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Edit User'
      })
    },
    props: ['id'],
    data () {
      return {
        fetching: true,
        sending: false,
        has_changed: false,
        updateSuccess: false,
        form: new ApiResource({
          role_id: '',
          original_role_id: '',
          email: ''
        })
      }
    },
    created () {
      this.getProfile()
    },
    methods: {
      /**
       * Determines whether or not the form is worth saving
       * @returns {void}
       */
      setChanged () {
        if (this.form.role_id !== this.form.original_role_id) {
          this.has_changed = true
        } else {
          this.has_changed = false
        }
      },
      /**
       * Gets info on invite to populate form
       * @returns {void}
       */
      getProfile () {
        this.form.send(`/invite/${this.id}`, {}, 'get')
          .then(() => {
            this.form.original_role_id = this.form.role_id
            this.fetching = false
          })
      },
      /**
       * Resets all data properties back to users listing
       * @returns {void}
       */
      cancel () {
        this.form.email = ''
        this.form.role_id = ''
        this.$router.push('/users')
      },
      /**
       * Processes form submission
       * @returns {void}
       */
      submitForm () {
        this.sending = true
        this.form.errors.clear()
        this.form.send(`/update-users-role/${this.id}`, {
          role_id: this.form.role_id,
          invite_id: this.id
        }, 'patch')
          .then((success) => {
            this.sending = false
            this.form.role_id = 3
            flash(success)
              dataLayer.push({
                  'userMessage': {
                      'messageType': 'success',
                      'messageName': 'Successfully updated user details on Edit Business User View',
                      'displayedMessage': success
                  }
              })
            this.$router.push('/users')
          })
          .catch(() => {
            this.sending = false
            flash(this.getErrorMessage(), 'is-danger')
              dataLayer.push({
                  'userMessage': {
                      'messageType': 'error',
                      'messageName': 'Failed to update user details on Edit Business User View',
                      'displayedMessage': this.getErrorMessage()
                  }
              })
          })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/users/EditUser.vue